import React from "react";
import aiImage from "../../../assets/cybersecurity.webp";
import strategyImage from "../../../assets/cybersecurity1.webp";
import strategyImage1 from "../../../assets/cybersecurity2.jpeg";

export default function Cybersecurity() {
  return (
    <div className="bg-white">
      {/* Hero Section */}
      <section className="relative h-[60vh] sm:h-[70vh] md:h-[800px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src={aiImage}
            alt="Cybersecurity"
            className="w-full h-full object-cover sm:object-contain md:object-cover"
          />
          <div className="absolute inset-0 bg-black/60"></div>
        </div>
        <div className="relative z-10 text-center text-white px-4 sm:px-6">
          <h1 className="text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-bold mb-4 leading-tight">
            Cybersecurity
          </h1>
          <p className="text-sm sm:text-lg md:text-xl lg:text-2xl max-w-3xl mx-auto leading-relaxed">
            Conduct risk assessments, build secure access control, and implement threat detection
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-8 sm:py-12 md:py-16 px-4 sm:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 items-center">
            {/* Image - Left Side */}
            <div className="flex-1 w-full">
              <img
                src={strategyImage}
                alt="Cybersecurity"
                className="w-full h-64 sm:h-80 md:h-96 object-cover rounded-lg shadow-lg"
              />
            </div>

            {/* Content - Right Side */}
            <div className="flex-1 w-full">
              <h2 className="text-xl sm:text-2xl md:text-3xl font-bold mb-4 sm:mb-6 text-[#482A7A] text-center lg:text-left">
                Cybersecurity
              </h2>
              <p className="text-sm sm:text-base md:text-lg text-gray-700 leading-relaxed mb-4 sm:mb-6 text-center lg:text-left">
                Conduct risk assessments, build secure access control, implement threat detection, and manage compliance audits.
              </p>
              <p className="text-sm sm:text-base md:text-lg text-gray-700 leading-relaxed text-center lg:text-left">
                Our comprehensive cybersecurity approach protects your organization from evolving threats while ensuring regulatory compliance and business continuity.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* IT Support Services Section */}
      <section className="py-8 sm:py-12 md:py-16 px-4 sm:px-6 bg-gray-50">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 items-center">
            {/* Content - Left Side */}
            <div className="flex-1 w-full">
              <h2 className="text-xl sm:text-2xl md:text-3xl font-bold mb-6 text-[#482A7A] text-center lg:text-left">
                IT support services
              </h2>
              <h3 className="text-lg sm:text-xl md:text-2xl font-semibold mb-8 text-center lg:text-left text-gray-800">
                Protect Your Digital Assets with Our Cybersecurity Services
              </h3>
              <p className="text-sm sm:text-base md:text-lg text-gray-700 text-center lg:text-left">
                Cybersecurity is paramount for businesses to safeguard their valuable assets. With the increasing frequency and sophistication of cyber threats, organisations face numerous challenges, including data breaches, malicious attacks, and regulatory compliance requirements. At Alif, we understand the critical importance of cybersecurity and are dedicated to providing an exceptional service to businesses.
              </p>
            </div>

            {/* Image - Right Side */}
            <div className="flex-1 w-full">
              <img
                src={strategyImage1}
                alt="IT Support Services Dubai"
                className="w-full h-64 sm:h-80 md:h-96 object-cover rounded-lg shadow-lg"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Comprehensive IT Security Services Section */}
      <section className="py-8 sm:py-12 md:py-16 px-4 sm:px-6">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-xl sm:text-2xl md:text-3xl font-bold mb-6 text-[#482A7A] text-center">
            Comprehensive IT Security Services Tailored to Your Needs
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-gray-700 mb-12 text-center max-w-4xl mx-auto">
            Alif offers a comprehensive suite of IT security services designed to address the evolving cyber threat landscape and meet the unique needs of businesses. Our services include:
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-lg border-l-4 border-blue-600">
              <h3 className="text-lg font-bold text-blue-600 mb-4">Cyber Security Consulting</h3>
              <p className="text-sm text-gray-600">
                Expert advisory services to assess your organisation's security posture, identify vulnerabilities, and develop customised solutions.
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg border-l-4 border-green-600">
              <h3 className="text-lg font-bold text-green-600 mb-4">Managed Security Services</h3>
              <p className="text-sm text-gray-600">
                Proactive monitoring and management of your IT infrastructure to detect and respond to security incidents in real time.
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg border-l-4 border-purple-600">
              <h3 className="text-lg font-bold text-purple-600 mb-4">Tailored Approach</h3>
              <p className="text-sm text-gray-600">
                We offer a tailored approach to our services, ensuring that our solutions are customised to fit your specific requirements and business objectives.
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg border-l-4 border-orange-600">
              <h3 className="text-lg font-bold text-orange-600 mb-4">Cloud Security Solutions</h3>
              <p className="text-sm text-gray-600">
                Ensuring the security of your cloud-based assets and applications through robust security measures and best practices.
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg border-l-4 border-red-600">
              <h3 className="text-lg font-bold text-red-600 mb-4">Incident Response and Management</h3>
              <p className="text-sm text-gray-600">
                Swift and efficient response to cybersecurity incidents to minimise disruption and mitigate potential damage.
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg border-l-4 border-indigo-600">
              <h3 className="text-lg font-bold text-indigo-600 mb-4">Compliance Assistance</h3>
              <p className="text-sm text-gray-600">
                Helping you navigate and comply with local and international cyber security regulations and standards.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Kew Solutions Section */}
      <section className="py-8 sm:py-12 md:py-16 px-4 sm:px-6 bg-gray-50">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-xl sm:text-2xl md:text-3xl font-bold mb-6 text-[#482A7A] text-center">
            Why Choose Alif as Your Trusted Cybersecurity Partner?
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-gray-700 mb-12 text-center max-w-4xl mx-auto">
            Alif has a proven track record of providing Cybersecurity services to businesses across multiple industries. We possess the ability to understand how businesses operate and advise on IT security services that protect your business and ensure it is compliant.Alif is your trusted partner for cybersecurity and here's why you should choose us:
          </p>
          
          <div className="flex flex-wrap justify-center gap-8">
            <div className="text-center w-full md:w-[calc(50%-16px)] lg:w-[calc(33.333%-22px)]">
              <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z" />
                </svg>
              </div>
              <h3 className="text-lg font-bold text-gray-800 mb-3">Client Centric Approach</h3>
              <p className="text-sm text-gray-600">
                With a client-centric approach, we prioritise understanding your business objectives and tailor our cybersecurity solutions to align with your strategic goals.
              </p>
            </div>
            
            <div className="text-center w-full md:w-[calc(50%-16px)] lg:w-[calc(33.333%-22px)]">
              <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-lg font-bold text-gray-800 mb-3">Continuous Monitoring</h3>
              <p className="text-sm text-gray-600">
                We provide continuous monitoring of your IT environment to detect and respond to security incidents in real-time, minimising potential damage and disruption to your operations.
              </p>
            </div>
            
            <div className="text-center w-full md:w-[calc(50%-16px)] lg:w-[calc(33.333%-22px)]">
              <div className="w-16 h-16 bg-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </div>
              <h3 className="text-lg font-bold text-gray-800 mb-3">Dedicated Team</h3>
              <p className="text-sm text-gray-600">
                Our dedicated team of cyber security professionals is committed to delivering personalised solutions and unparalleled support to meet your unique security needs.
              </p>
            </div>
            
            <div className="text-center w-full md:w-[calc(50%-16px)] lg:w-[calc(33.333%-22px)]">
              <div className="w-16 h-16 bg-orange-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
              <h3 className="text-lg font-bold text-gray-800 mb-3">Cutting-Edge Software</h3>
              <p className="text-sm text-gray-600">
                We leverage cutting-edge software to stay ahead of emerging cyber threats, ensuring proactive protection for your organisation.
              </p>
            </div>
            
            <div className="text-center w-full md:w-[calc(50%-16px)] lg:w-[calc(33.333%-22px)]">
              <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
                </svg>
              </div>
              <h3 className="text-lg font-bold text-gray-800 mb-3">Proven Track Record</h3>
              <p className="text-sm text-gray-600">
                We have a proven track record of successfully securing organisations across various industries, providing peace of mind and confidence in our capabilities.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}